import {faChartWaterfall} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Skeleton} from 'antd';
import {useState} from 'react';

import {appRoute} from '../../../../app-route';
import {Meta} from '../../../../component/meta/meta';
import {BreadCrumbs} from '../../../../layout/bread-crumbs/bread-crumbs';
import {Page} from '../../../../layout/page/page';
import {MainPageContainer} from '../../../../layout/page-card/main-page-card';
import {PageCard} from '../../../../layout/page-card/page-card';
import {PageHeader} from '../../../../layout/page-header/page-header';
import {useLocale} from '../../../../provider/locale/locale-hook';
import {Locale} from '../../../../provider/locale/localization';
import {classNames} from '../../../../util/css';

import {doubleGisProTestSceneUrl} from './online-presence-pro-const';
import * as styles from './online-presence-pro.scss';

export function OnlinePresencePro(): JSX.Element {
    const {getLocalizedString} = useLocale();

    const [isLoaded, setIsLoaded] = useState<boolean>(false);

    return (
        <Page renderContainer={(pageContent) => <MainPageContainer>{pageContent}</MainPageContainer>}>
            <Meta title={getLocalizedString('CATEGORY_NAME__ONLINE_PRESENCE__ANALYTICS_PRO')} />
            <PageCard>
                <BreadCrumbs
                    list={[
                        {
                            path: appRoute.onlinePresenceDashboard.path,
                            titleLangKey: 'ONLINE_PRESENCE_ANALYTICS__BREAD_CRUMBS',
                        },
                        {
                            path: appRoute.onlinePresencePro.path,
                            titleLangKey: 'CATEGORY_NAME__ONLINE_PRESENCE__ANALYTICS_PRO',
                        },
                    ]}
                />

                <PageHeader>
                    <Locale stringKey="CATEGORY_NAME__ONLINE_PRESENCE__ANALYTICS_PRO" />
                </PageHeader>
            </PageCard>

            <div className={styles.OnlinePresencePro_wrapper}>
                {/* eslint-disable-next-line react/iframe-missing-sandbox */}
                <iframe
                    allowFullScreen
                    className={classNames(styles.OnlinePresencePro_iframe, {
                        [styles.OnlinePresencePro_iframe__initialized]: isLoaded,
                    })}
                    onLoad={() => setIsLoaded(true)}
                    src={doubleGisProTestSceneUrl}
                    title="analytics-pro"
                />

                {!isLoaded && (
                    <Skeleton.Node active className={styles.OnlinePresencePro_skeleton}>
                        <FontAwesomeIcon icon={faChartWaterfall} size="3x" />
                    </Skeleton.Node>
                )}
            </div>
        </Page>
    );
}
